import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

         // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================            
              {
                path: '/',
                redirect: '/login'
              },  
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/Login.vue')
              },
              {
                path: '/error-404',
                name: 'page-error-404',
                component: () => import('@/views/Error404.vue')
              },
            ]
        },
        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/home',
                name: 'home',
                component: () => import('./views/Home.vue'),
                meta: {                       
                  pageTitle: 'Dashboard',
                }
              },
              {
                path: '/cadastro/empresas/pesquisar',
                name: 'cadastro-empresas-pesquisar',
                component: () => import('./views/cadastros/empresas/Empresa.vue'),
                meta: {                       
                  pageTitle: 'Empresas',
                }
              },
              {
                path: '/cadastro/empresas/editar',
                name: 'cadastro-empresas-editar',
                component: () => import('./views/cadastros/empresas/EmpresaEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Empresa',
                }
              },
              {
                path: '/cadastro/favorecidos/pesquisar',
                name: 'cadastro-favorecidos-pesquisar',
                component: () => import('./views/cadastros/favorecidos/Favorecido.vue'),
                meta: {                       
                  pageTitle: 'Favorecidos',
                }
              },
              {
                path: '/cadastro/favorecidos/editar',
                name: 'cadastro-favorecidos-editar',
                component: () => import('./views/cadastros/favorecidos/FavorecidosEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Favorecido',
                }
              },
              {
                path: '/cadastro/categorias-produtos/pesquisar',
                name: 'cadastro-categorias-produtos-pesquisar',
                component: () => import('./views/cadastros/categorias-produtos/Categoria.vue'),
                meta: {                       
                  pageTitle: 'Categorias de Produtos',
                }
              },
              {
                path: '/cadastro/categorias-produtos/editar',
                name: 'cadastro-categorias-produtos-editar',
                component: () => import('./views/cadastros/categorias-produtos/CategoriaEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Categoria de Produtos',
                }
              },
              {
                path: '/cadastro/produtos/pesquisar',
                name: 'cadastro-produtos-pesquisar',
                component: () => import('./views/cadastros/produtos/Produto.vue'),
                meta: {                       
                  pageTitle: 'Produtos',
                }
              },
              {
                path: '/cadastro/produtos/editar',
                name: 'cadastro-produtos-editar',
                component: () => import('./views/cadastros/produtos/ProdutoEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Produto',
                }
              },
              {
                path: '/cadastro/grupos-contas/pesquisar',
                name: 'cadastro-grupos-contas-pesquisar',
                component: () => import('./views/cadastros/grupos-contas/GrupoConta.vue'),
                meta: {                       
                  pageTitle: 'Grupos de Contas',
                }
              },
              {
                path: '/cadastro/grupos-contas/editar',
                name: 'cadastro-grupos-contas-editar',
                component: () => import('./views/cadastros/grupos-contas/GrupoContaEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Grupos de Contas',
                }
              },
              {
                path: '/cadastro/contas/pesquisar',
                name: 'cadastro-contas-pesquisar',
                component: () => import('./views/cadastros/contas/Conta.vue'),
                meta: {                       
                  pageTitle: 'Contas',
                }
              },
              {
                path: '/cadastro/contas/editar',
                name: 'cadastro-contas-editar',
                component: () => import('./views/cadastros/contas/ContaEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Conta',
                }
              },
              {
                path: '/financeiro/contas-a-pagar/pesquisar',
                name: 'financeiro-contas-a-pagar-pesquisar',
                component: () => import('./views/financeiro/contas-a-pagar/ContasAPagar.vue'),
                meta: {                       
                  pageTitle: 'Contas a Pagar',
                }
              },
              {
                path: '/financeiro/contas-a-pagar/editar',
                name: 'financeiro-contas-a-pagar-editar',
                component: () => import('./views/financeiro/contas-a-pagar/ContasAPagarEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Conta a Pagar',
                }
              },
              {
                path: '/financeiro/contas-a-receber/pesquisar',
                name: 'financeiro-contas-a-receber-pesquisar',
                component: () => import('./views/financeiro/contas-a-receber/ContasAReceber.vue'),
                meta: {                       
                  pageTitle: 'Contas a Receber',
                }
              },
              {
                path: '/financeiro/contas-a-receber/editar',
                name: 'financeiro-contas-a-receber-editar',
                component: () => import('./views/financeiro/contas-a-receber/ContasAReceberEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Conta a Receber',
                }
              },

              {
                path: '/financeiro/item-conta-futuro/pesquisar',
                name: 'financeiro-item-conta-futuro-pesquisar',
                component: () => import('./views/financeiro/item-conta-futuro/ItemContaFuturo.vue'),
                meta: {                       
                  pageTitle: 'Itens de Conta Futuros',
                }
              },
              {
                path: '/financeiro/item-conta-futuro/editar',
                name: 'financeiro-item-conta-futuro-editar',
                component: () => import('./views/financeiro/item-conta-futuro/ItemContaFuturoEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Item de Conta Futuro',
                }
              },

              {
                path: '/financeiro/conta-recorrente/pesquisar',
                name: 'financeiro-conta-recorrente-pesquisar',
                component: () => import('./views/financeiro/conta-recorrente/ContaRecorrente.vue'),
                meta: {                       
                  pageTitle: 'Contas Recorrente',
                }
              },
              {
                path: '/financeiro/conta-recorrente/editar',
                name: 'financeiro-conta-recorrente-editar',
                component: () => import('./views/financeiro/conta-recorrente/ContaRecorrenteEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Conta Recorrente',
                }
              },


              {
                path: '/financeiro/compras/pesquisar',
                name: 'financeiro-compras-pesquisar',
                component: () => import('./views/financeiro/compras/Compra.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Compras',
                }
              },
              {
                path: '/financeiro/compras/editar',
                name: 'financeiro-compras-editar',
                component: () => import('./views/financeiro/compras/CompraEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Compras',
                }
              },
              {
                path: '/financeiro/remessa/pesquisar',
                name: 'financeiro-remessa-pesquisar',
                component: () => import('./views/financeiro/remessa-bancaria/Remessa.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Gerar Remessa Bancária',
                }
              },
              {
                path: '/financeiro/retorno/processar',
                name: 'financeiro-remessa-processar',
                component: () => import('./views/financeiro/retorno-bancario/Retorno.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Processar Retorno Bancário',
                }
              },
              {
                path: '/cadastro/usuarios/pesquisar',
                name: 'cadastro-usuarios-pesquisar',
                component: () => import('./views/cadastros/usuarios/Usuario.vue'),
                meta: {                       
                  pageTitle: 'Usuários',
                }
              },
              {
                path: '/cadastro/usuarios/editar',
                name: 'cadastro-usuarios-editar',
                component: () => import('./views/cadastros/usuarios/UsuarioEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Usuário',
                }
              },

              {
                path: '/cadastro/instituicoes/pesquisar',
                name: 'cadastro-instituicoes-pesquisar',
                component: () => import('./views/cadastros/instituicoes/Instituicao.vue'),
                meta: {                       
                  pageTitle: 'Instituições',
                }
              },
              {
                path: '/cadastro/instituicoes/editar',
                name: 'cadastro-instituicoes-editar',
                component: () => import('./views/cadastros/instituicoes/InstituicaoEdit.vue'),
                props: true ,
                meta: {                       
                  pageTitle: 'Instituição',
                }
              },

              {
                path: '/relatorios',
                name: 'relatorios',
                component: () => import('./views/relatorios/Relatorios2.vue'),
                props: true ,                
              },
            ],
        },
   
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
